import { useIntl } from 'react-intl';

import type { Tour } from '#domain/Tour.ts';

import { TourStatusData } from '../model/TourStatusData.ts';

const StatusTableCell = ({ tour }: { tour: Tour }) => {
    const intl = useIntl();
    const { color, icon, id } = TourStatusData[tour.status];

    return (
        <span className='white-space-nowrap'>
            <span className={`label label-${color}`}>
                <span className='display-flex align-items-center gap-5'>
                    <span className={`uikit-icon icon-${icon}`} />
                    <span>{intl.formatMessage({ id })}</span>
                </span>
            </span>
        </span>
    );
};

export default StatusTableCell;
